export enum PhaseStatus {
    COMPLETED = "COMPLETED",
    NEW = "NEW",
    FAILED = "FAILED",
    IN_PROGRESS = "IN_PROGRESS",
    NOT_STARTED = "NOT_STARTED",
    READY = "READY",
    REJECTED = "REJECTED",
    REOPENED = "REOPENED",
    SKIPPED = "SKIPPED",
    EXPIRED = "EXPIRED"
}

export enum ContentType {
    AVAILABLE = "AVAILABLE",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
}

export enum FilterType {
    CLAIMABLE = "CLAIMABLE",
    ONGOING = "ONGOING",
    NEW = "NEW",
    CONTINUE = "CONTINUE",
    DONE = "DONE"
}

export enum ProgressBarColors {
    COMPLETED = "#1C8843",
    IN_PROGRESS = "#2375BD",
    REJECTED = "#D62027",
    READY = "#E5EBEF"
}

export enum JobTag {
    REGULAR = "REGULAR",
    OPEN = "OPEN",
    CLONE = "CLONE",
    GEOSPATIAL = "GEOSPATIAL",
    EXPIRED = "EXPIRED",
    REJECTED = "REJECTED",
    COMPLETED = "COMPLETED",
    APPROVED_FOR_PAYMENT = "APPROVED_FOR_PAYMENT"
}

export enum TestTag {
    PENDING = "PENDING",
    PASS = "PASS",
    FAILED = "FAILED"
}

export enum ActivityNotification {
    REOPEN = "REOPEN",
    COMPLETE = "COMPLETE",
    REJECT = "REJECT",
    ERROR = "ERROR",
    MOVE_TO = "MOVE_TO"
}

export enum LocalePrefix {
    JOB = "job",
    TEST = "test"
}

export enum ProjectType {
    TRANSCRIPTION = "TRANSCRIPTION",
    ANNOTATION = "ANNOTATION",
    NEA = "NEA",
    EXTERNAL = "EXTERNAL",
    OTHER = "OTHER",
}

export enum IconJobType {
    TRANSCRIPTION = "transcription",
    ANNOTATION = "annotation",
    NEA = "nea",
    SEGMENTATION = "segmentation",
    COLLECTION = "collection",
    MOBILE = "mobile",
    EXTERNAL = "external",
}

export enum Codes412 {
    NOT_READY = "NOT_READY",
}

export enum Codes409 {
    POOL_CLAIM_LIMIT = "POOL_CLAIM_LIMIT",
    POOL_ONGOING_LIMIT = "POOL_ONGOING_LIMIT"
}

export enum TestSkills {
    LANGUAGE = "LANGUAGE",
    TRANSCRIPTION = "TRANSCRIPTION",
    ANNOTATION = "ANNOTATION"
}

export enum MediaType {
    AUDIO = "audio",
    VIDEO = "video",
}

export enum TestScoreStatus {
    PENDING = "PENDING",
    NOT_EVALUATED = "NOT_EVALUATED",
    FAILED = "FAILED",
    PASS = "PASS"
}

export enum NoResultType {
    SEARCH_NOT_FOUND = "SEARCH_NOT_FOUND",
    FILTER_NOT_FOUND = "FILTER_NOT_FOUND",
}

export enum DueDateFormat {
    HOUR = "HOUR",
    DAY = "DAY"
}

export enum SortDirection {
    ASC = "ASC",
    DESC = "DESC",
}

export enum MessageAction {
    REQUEST_DOMAINS = "REQUEST_DOMAINS",
    DOMAINS = "DOMAINS",
    TASK_PARAMS = "TASK_PARAMS",
}
